import { render, staticRenderFns } from "./pkbDetailsTable.vue?vue&type=template&id=4ae47578&scoped=true"
import script from "./pkbDetailsTable.vue?vue&type=script&lang=js"
export * from "./pkbDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./pkbDetailsTable.vue?vue&type=style&index=0&id=4ae47578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae47578",
  null
  
)

export default component.exports